import React from "react";
import { cn } from "tailwind-variants";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import GangSheetBuilderContainer from "./GangSheetBuilderContainer.vue";
import { useDtfStore } from "./store";
import "./UploadBox.scss";

export default function UploadBox({ onUpload, ...restProps }) {
  const store = useDtfStore();

  // Computed properties
  function pdpType() {
    return store.pdpType;
  }

  function printAsIs() {
    return store.printAsIs;
  }

  function dtfTypeDropText() {
    return store.dtfTypeDropText;
  }

  function businessLine() {
    return store.businessLine;
  }

  function showMultiSize() {
    return store.showMultiSize;
  }

  function isStandardArtwork() {
    return store.isStandardArtwork;
  }

  function showGangSheetBuilderFeature() {
    return store.showGangSheetBuilderFeature;
  }

  function userType() {
    return store.userType;
  }

  function showModal() {
    return store.showModal;
  }

  function showArtworkHistoryModal() {
    return store.showArtworkHistoryModal;
  }

  function isUserSignedIn() {
    return userType() === "signed_in";
  }

  function isMultiUpload() {
    return showModal();
  }

  // Methods
  function setShowArtworkHistoryModal(...args) {
    return store.setShowArtworkHistoryModal(...args);
  }

  function trackAddFileAreaClick() {
    submitDtfEvent("transfer_choose_file_clicked", {
      page: "pdp",
      pdp_type: pdpType(),
      business_line: businessLine()
    });
  }

  function handleUpload() {
    trackAddFileAreaClick();
    onUpload?.();
  }

  function onArtworkHistoryClick() {
    setShowArtworkHistoryModal(!showArtworkHistoryModal());
    submitDtfEvent("previous_purchase_link_clicked", {
      page: "pdp",
      pdp_type: pdpType()
    });
  }

  return (
    <div
      {...restProps}
      className={cn(
        "upload-box scope-e4c73329",
        restProps?.className,
        showMultiSize() && "upload-box--multi-size"
      )}
    >
      <div className="upload-box__title scope-e4c73329">More files to upload?</div>
      <div
        className={cn(
          "upload-box__wrapper scope-e4c73329",
          isStandardArtwork() && "upload-box__wrapper--standard-artwork"
        )}
        onClick={handleUpload}
        data-testid="upload-box-wrapper"
      >
        <span className="upload-box__label-title hidden-xs scope-e4c73329">
          {dtfTypeDropText()}
        </span>
        {printAsIs() ? (
          <span className="upload-box__label-title visible-xs scope-e4c73329">
            {dtfTypeDropText()}
          </span>
        ) : (
          <span className="upload-box__label-title visible-xs scope-e4c73329">
            {" "}
            Tap anywhere to choose your images{" "}
          </span>
        )}
        <div className="upload-box__action-buttons scope-e4c73329">
          {showGangSheetBuilderFeature() ? (
            <GangSheetBuilderContainer
              className="scope-e4c73329"
              data-testid="gang-sheet-builder-container"
            />
          ) : null}
          <span
            className={cn(
              "upload-box__action scope-e4c73329",
              isStandardArtwork() && "upload-box__action--standard-artwork"
            )}
          >
            {" "}
            Choose files{" "}
          </span>
        </div>
        {isUserSignedIn() && !isMultiUpload() ? (
          <a
            className="upload-box__dropzone-button scope-e4c73329"
            href="#"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              onArtworkHistoryClick();
            }}
            data-testid="upload-box-dropzone-button"
          >
            {" "}
            My Design Library{" "}
          </a>
        ) : null}
      </div>
    </div>
  );
}
